import React from "react";

export const Span: React.FC<React.HTMLProps<HTMLSpanElement>> = (
  props: React.HTMLProps<HTMLSpanElement>
) => <span {...props}>{props.children}</span>;
